import React, { useEffect, useState } from 'react';
import { DecisionComparison as Comparison, EvidenceScope, RecentMatch, getDecisionComparison } from '../../../api/cafAutomation';
import { Drawer } from '../Overlay';
import { PredictedSteps } from './PredictedSteps';
import { StepChips } from './StepChips';
import { decisionOutcomeLine } from './automationCopy';

const DecisionSide: React.FC<{ title: string; item: RecentMatch | null }> = ({ title, item }) => <section>
  <h3>{title}</h3>
  {!item ? <p>No live decision recorded.</p> : <>
    <p>{item.workflow?.name || 'Manual decision'}{item.workflow?.version ? ` · version ${item.workflow.version}` : ''}</p>
    <p>{item.source?.label || 'Source not recorded'}</p>
    {item.plan && <><StepChips steps={item.plan.cards || []} /><p>Proposed ending: {item.plan.ending || 'None'}</p></>}
    <PredictedSteps predictions={item.predictions} />
    <p>{decisionOutcomeLine(item)}</p>
  </>}
</section>;

export const DecisionComparison: React.FC<{ decisionId: string; scope: EvidenceScope; onClose: () => void }> =
  ({ decisionId, scope, onClose }) => {
    const [data, setData] = useState<Comparison | null>(null);
    const [problem, setProblem] = useState('');
    useEffect(() => {
      let active = true;
      getDecisionComparison(decisionId, scope).then((next) => {
        if (active) { setData(next); setProblem(''); }
      }, () => { if (active) setProblem("Couldn't load the comparison."); });
      return () => { active = false; };
    }, [decisionId, scope]);
    return <Drawer eyebrow="Saved evidence" title="Watching and live" onClose={onClose}
      footer={<button type="button" className="ui-btn ui-btn--ghost ui-btn--md" onClick={onClose}>Close</button>}>
      {problem && <p role="alert">{problem}</p>}
      {!data && !problem && <p>Loading…</p>}
      {data && <div className="cur-stack">
        <DecisionSide title="Observed in Watching" item={data.watch} />
        <DecisionSide title="Live decision" item={data.live} />
        {!data.live && data.current_eligibility && <p>Current pending eligibility: {data.current_eligibility.eligible_waiting ? 'Waiting and eligible' : 'Not currently eligible'}. This is not a planned or executed workflow.</p>}
        {data.changed_fields.length > 0 && <p>{data.changed_fields.map((item) => item.field.replace(/_/g, ' ')).join(', ')} changed between these saved decisions.</p>}
      </div>}
    </Drawer>;
  };
